var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classObj
  }, [_vm._t("default"), _vm._v(" "), (_vm.loading) ? _c('n3-loading', {
    staticStyle: {
      "position": "relative",
      "top": "2px"
    },
    attrs: {
      "size": "xs"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.badge) ? _c('n3-badge', [_vm._v(_vm._s(_vm.badge))]) : _vm._e()], 2)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6265de1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6265de1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Button/n3Button.vue
// module id = 633
// module chunks = 0 1